import store from '@/store'
import { ref, watch, getCurrentInstance, computed } from '@vue/composition-api'
import { skutopiaRequest, foundryRequest } from '@/config/authConfig';
import { followCursor } from 'tippy.js';
import router from '@/router'

export default function usePOG() {
    const planogramsData = ref([])
    const vm = getCurrentInstance().proxy

    // Data table options
    const options = ref({
      sortBy: ['id'],
      sortDesc: [true],
      orderBy:'',
      page:1,
      itemsPerPage: 25 //parseInt(process.env.VUE_APP_ITEMS_PER_PAGE)
    })
    const selectedCategory = ref()
    const searchQuery = ref('')
    const selectedRows = ref([])
    const pogLoading = ref(false)
    const totalPOGs = ref(0)
    const planogram = ref({})
    const downloadLoading = ref(false)
    const imageLoading = ref(false)
    const planogramUploadLoading = ref()
    const categoryLoading = ref(false)
    const categoryOptions = ref([])
    const categorySearch = ref('')

    const pogStatus = ref([
      {text: 'Pending', value: 'PEND'},
      {text: 'In Progress', value: 'PROG'},
      {text: 'Completed', value: 'COMP'},
      {text: 'Cancelled', value: 'CNLD'},
    ])

    const resolveStatus = status => {
        if (status == 'COMP')
          return {
            text: 'Completed',
            color: 'success',
          }
        if (status == 'PROG')
          return {
            text: 'In Progress',
            color: 'secondary',
          }
        if (status == 'PEND')
          return {
            text: 'Pending',
            color: 'warning',
          }
        if (status == 'CNLD')
          return {
            text: 'Cancelled',
            color: 'error',
          }
      }
      
      const projectSearchQuery = ref('')
      const projectOptions = ref({
        sortBy: ['job_number'],
        sortDesc: [true],
        orderBy:'',
        page:1,
        itemsPerPage: 10 //parseInt(process.env.VUE_APP_ITEMS_PER_PAGE)
      })
      const lighthouseProjectsData = ref([])
      const totalProjectListTable = ref(0)
      const projectFields = ['id', 'job_number', 'job_name', 'countries', 'category', 'project_type', 'service_type', 'office', 'client', 'brand', 'business_initiative']
      
      const fetchProjects = async (search='') => {
          
          store
            .dispatch('app-project/fetchProjects', {
              search: search,
              fields: projectFields,
              options: JSON.stringify(projectOptions.value),
              page: projectOptions.value.page,
              
            })
            .then(response => {
              const { results, count, total_pages } = response.data
              
              lighthouseProjectsData.value = results
              totalProjectListTable.value = count
      
            })
            .catch(error => {
              console.log(error)
            })
        }
  

        const downloadMissingProducts = async (instance) => {
          
          downloadLoading.value = true
          store
          .dispatch('app-skutopia/downloadMissingProducts', 
            instance.id
          )
          .then(response => {
              const { data } = response
              downloadLoading.value = false
              let fileURL = window.URL.createObjectURL(new Blob([data]));
              let fileLink = document.createElement('a');
          
              fileLink.href = fileURL;
              fileLink.setAttribute('download', `${instance.project}_POG${instance.id}_MissingProducts.xlsx`);
              document.body.appendChild(fileLink);
          
              fileLink.click();
  
          })
          .catch(error => {
              downloadLoading.value = false
              // store.commit('app/LOADING', false)
              console.log(error.response)
              store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
          })
      }

      const downloadDOCXProducts = async (instance) => {
        
        downloadLoading.value = true
        store
        .dispatch('app-skutopia/downloadDOCXProducts', 
          instance.id
        )
        .then(response => {
            const { data } = response
            downloadLoading.value = false
            let fileURL = window.URL.createObjectURL(new Blob([data]));
            let fileLink = document.createElement('a');
        
            fileLink.href = fileURL;
            fileLink.setAttribute('download', `${instance.project}_POG${instance.id}_images.docx`);
            document.body.appendChild(fileLink);
        
            fileLink.click();

        })
        .catch(error => {
            downloadLoading.value = false
            // store.commit('app/LOADING', false)
            console.log(error.response)
            store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })
    }
  


    const downloadPOGPSD = async (instance) => {
        
        downloadLoading.value = true
        store
        .dispatch('app-skutopia/downloadPOGPSD', 
          instance.id
        )
        .then(response => {
            const { data } = response
            downloadLoading.value = false
            let fileURL = window.URL.createObjectURL(new Blob([data]));
            let fileLink = document.createElement('a');
        
            fileLink.href = fileURL;
            fileLink.setAttribute('download', `${instance.project}_POG${instance.id}_PSD.zip`);
            document.body.appendChild(fileLink);
        
            fileLink.click();

        })
        .catch(error => {
            downloadLoading.value = false
            // store.commit('app/LOADING', false)
            console.log(error.response)
            store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
        })
    }

    const downloadPNG = async (instance, sides) => {
      
      downloadLoading.value = true
      store
      .dispatch('app-skutopia/downloadPNG', 
        {id: instance.id, sides: sides}
      )
      .then(response => {
          const { data } = response
          downloadLoading.value = false
          let fileURL = window.URL.createObjectURL(new Blob([data]));
          let fileLink = document.createElement('a');
      
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${instance.project}_POG${instance.id}_PNG.zip`);
          document.body.appendChild(fileLink);
      
          fileLink.click();

      })
      .catch(error => {
          downloadLoading.value = false
          // store.commit('app/LOADING', false)
          console.log(error.response)
          store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
      })
    }

    const downloadDecipherPNG = async (instance, sides) => {
      
      downloadLoading.value = true
      store
      .dispatch('app-skutopia/downloadDecipherPNG', 
        {id: instance.id, sides: sides}
      )
      .then(response => {
          const { data } = response
          downloadLoading.value = false
          let fileURL = window.URL.createObjectURL(new Blob([data]));
          let fileLink = document.createElement('a');
      
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${instance.project}_POG${instance.id}_Decipher.zip`);
          document.body.appendChild(fileLink);
      
          fileLink.click();

      })
      .catch(error => {
          downloadLoading.value = false
          // store.commit('app/LOADING', false)
          console.log(error.response)
          store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
      })
    }

    const downloadPOGXLSX = async (instance) => {
      
      downloadLoading.value = true
      store
      .dispatch('app-skutopia/downloadPOGXLSX', 
          instance.id
        )
      .then(response => {
          const { data } = response
          downloadLoading.value = false
          let fileURL = window.URL.createObjectURL(new Blob([data]));
          let fileLink = document.createElement('a');
      
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${instance.project}_POG${instance.id}_POG_File.xlsx`);
          document.body.appendChild(fileLink);
      
          fileLink.click();

      })
      .catch(error => {
          downloadLoading.value = false
          // store.commit('app/LOADING', false)
          console.log(error.response)
          store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
      })
    }
    const addPOGShelfImage = async (id, file) => {
      
      const payload = {
        id: id,
        file: file
      }
      imageLoading.value = true
      return await store
      .dispatch('app-skutopia/addPOGShelfImage', payload)
      .then(response => {
          const { data } = response
          imageLoading.value = false
          return data

      })
      .catch(error => {
        imageLoading.value = false
          // store.commit('app/LOADING', false)
          console.log(error)
          // store.commit('comp-alert/SET_MESSAGE', error.response.statusText)
      })

    }

    const fetchPOGs = async (params = {}) => {
        
        pogLoading.value = true
        
          const paramsQuery =  {
            search: searchQuery.value || "",
            category: selectedCategory.value,
            options:JSON.stringify(options.value),
            page:options.value.page,
          
        }
        Object.keys(params).forEach(key => {
          paramsQuery[key] = params[key] // Output: name, age, city
        });

        store
            .dispatch('app-skutopia/fetchPOGs', paramsQuery)
            .then(response => {
              const { results, count, total_pages } = response.data
              
              planogramsData.value = results
              totalPOGs.value = count
      
              // remove loading state
              pogLoading.value = false
            })
            .catch(error => {
              console.log(error)
            })
    }

    const fetchPOG = async (id) => {
        
        
        pogLoading.value = true
        await store
        .dispatch('app-skutopia/fetchPOG', id, {})
        .then(response => {
            // remove loading state
            pogLoading.value = false
            planogram.value =  response.data
            
        })
        .catch(error => {
            // remove loading state
            pogLoading.value = false
            console.log(error)
        })
    }

    
    const deletePOG = async (id) => {
        
        
        pogLoading.value = true
        await store
        .dispatch('app-skutopia/deletePOG', id)
        .then(response => {
            // remove loading state
            pogLoading.value = false
            fetchPOGs()
            
        })
        .catch(error => {
            // remove loading state
            pogLoading.value = false
            console.log(error)
        })
    }

    const addPOG = async (project, file) => {
      const formPOG = new FormData()
      formPOG.append('file', file)
      formPOG.append(`job_number`, project.job_number);
      formPOG.append(`job_name`, project.job_name);
      formPOG.append(`country`, project.country_code);
      formPOG.append(`category`,  project.category);
      
      planogramUploadLoading.value = true

      store
        .dispatch('app-skutopia/addPOG', formPOG)
        .then(response => {
            const { data } = response
            planogramUploadLoading.value = false
            if (data.planogram.project) router.push({ name: 'planogram-id', params: { id: data.planogram.id }})
            

        })
        .catch(error => {
            planogramUploadLoading.value = false
            console.log(error)
        })
    }

    const editPOG = async (id, payload) => {
      const formPOG = new FormData()
      for (const [key, value] of Object.entries(payload)) {
        formPOG.append(key, value)
      }
      planogramUploadLoading.value = true

      return await store
        .dispatch('app-skutopia/editPOG', {id, payload:formPOG})
        .then(response => {
            const { data } = response
            planogramUploadLoading.value = false
            
            return data
            

        })
        .catch(error => {
          planogramUploadLoading.value = false
            console.log(error)
        })
    }
        
    
        const fetchCategories = async () => {
          
          
          categoryLoading.value = true
          await store
            .dispatch('app-skutopia/fetchProjCategories', {       
            })
            .then(response => {
              const { data } = response
              
              categoryOptions.value = data
              // remove loading state
              categoryLoading.value = false
            })
            .catch(error => {
              console.log(error)
            })
        }
      

    const updatePOGProduct = async (payload) => {
        
      
      pogLoading.value = true
      await store
      .dispatch('app-skutopia/updatePOGProduct', payload)
      .then(response => {
          // remove loading state
          pogLoading.value = false
          // planogram.value =  response.data
          
      })
      .catch(error => {
          // remove loading state
          pogLoading.value = false
          console.log(error)
      })
  }

    return {
        planogramsData,
        options,
        searchQuery,
        pogLoading,
        totalPOGs,
        pogStatus,
        planogram,
        downloadPOGPSD,
        downloadPNG,
        downloadDecipherPNG,
        downloadPOGXLSX,
        imageLoading,
        downloadLoading,
        downloadMissingProducts,
        downloadDOCXProducts,
        planogramUploadLoading,
        projectSearchQuery,
        projectOptions,
        lighthouseProjectsData,
        totalProjectListTable,
        categoryLoading,
        categoryOptions,
        categorySearch,
    
    
        fetchProjects,
        fetchCategories,

        addPOGShelfImage,
        resolveStatus,
        fetchPOGs,
        fetchPOG,
        addPOG,
        editPOG,
        deletePOG,
        updatePOGProduct
    }

}
